import {
  CLOSE_POPUP,
  OPEN_POPUP,
  SET_CURRENT_SCREEN_TYPE,
  LOGIN_USER,
  LOGOUT_USER,
  SHOW_ACCOUNT_ICON,
} from "../actionType";
import { SCREEN } from "../constants/Global";

const initialState = {
  isActive: false,
  screen: SCREEN.LOG_IN,
  userInfo: null,
  isLoggedIn: false,
  showIcon: false,
};

export const account = (state = initialState, action) => {
  switch (action.type) {
    case OPEN_POPUP:
      return {
        ...state,
        isActive: true,
        screen: action.screen,
      };
    case CLOSE_POPUP:
      return {
        ...state,
        isActive: false,
      };
    case SET_CURRENT_SCREEN_TYPE:
      return {
        ...state,
        screen: action.screen,
      };
    case LOGIN_USER:
      return {
        ...state,
        userInfo: action.userInfo,
        isLoggedIn: true,
        isActive: false,
        showIcon: true,
      };
    case LOGOUT_USER:
      return {
        ...initialState,
        showIcon: true,
      };
    case SHOW_ACCOUNT_ICON:
      return {
        ...state,
        showIcon: true,
      };
    default:
      return state;
  }
};
